import React from 'react';
import { Box } from '@mui/material';
import { chipColors } from '../theme/theme';
import { statusLabel } from '../utils/format';

/**
 * Pill status chip. `status` keys into the theme chipColors palette; `label`
 * overrides the auto title-cased text. Mirrors prototype BQ.chip.
 */
const StatusChip: React.FC<{ status: string; label?: string }> = ({ status, label }) => {
  const [bg, fg] = chipColors[status] || chipColors.inactive;
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex', alignItems: 'center', whiteSpace: 'nowrap',
        px: 1.25, py: '3px', borderRadius: '999px', fontSize: 12, fontWeight: 600,
        lineHeight: 1.6, bgcolor: bg, color: fg,
      }}
    >
      {label || statusLabel(status)}
    </Box>
  );
};

export default StatusChip;
